import { Routes } from '@angular/router';
import { KeyInPasscodeComponent } from "./key-in-passcode.component";

export const KeyInPasscodeRoutes: Routes = [
  { path: '', component: KeyInPasscodeComponent, pathMatch: 'full' }
];

